import { render, staticRenderFns } from "./ConfigUser.vue?vue&type=template&id=901c8e7a&scoped=true&"
import script from "./ConfigUser.vue?vue&type=script&lang=js&"
export * from "./ConfigUser.vue?vue&type=script&lang=js&"
import style0 from "./ConfigUser.vue?vue&type=style&index=0&id=901c8e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901c8e7a",
  null
  
)

export default component.exports